// src/slices/hrSettingsThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getInstitutionApi } from "../../../apiservice/setting";

// 🔹 Fetch HR Settings
export const fetchHrSettings = createAsyncThunk(
  "hrSettings/fetchHrSettings",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getInstitutionApi();
      return res?.data || {};
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

